@if (settings(); as setting) {
  <div class="footer">
    <div class="top-footer flex flex-column justify-content-center align-items-center">
      <div class="footer-logo">
        <img [src]="setting.header.logo" alt="Logo" height="auto" width="200" loading="lazy" />
      </div>
      <div class="footer-container">
        <div class="top-footer-item" id="footer-contact-number">
          <div>
            <h3 class="footer-item-title text-color">CONTATTACI</h3>
            <div class="desc">
              <div class="footer-item-desc">
                <a [href]="'tel:' + setting.footer.contact.phone" class="text-color"
                  >Telefono: {{ setting.footer.contact.phone }}</a
                >
              </div>
              @if (setting.footer.contact.fax) {
                <div class="footer-item-desc text-color">Fax: {{ setting.footer.contact.fax }}</div>
              }
            </div>
          </div>
        </div>
        <div class="top-footer-item pipe-start" id="footer-contact-email">
          <div>
            <h3 class="footer-item-title text-color">SCRIVICI SU</h3>
            <div class="desc">
              <div class="footer-item-desc">
                <a [href]="'mailto:' + setting.footer.emails.support" class="text-color">{{
                  setting.footer.emails.support
                }}</a>
              </div>
              @if (setting.footer.emails.managment) {
                <div class="footer-item-desc text-color">
                  {{ setting.footer.emails.managment }}
                </div>
              }
            </div>
          </div>
        </div>
        <div class="top-footer-item pipe-start" id="footer-contact-address">
          <div>
            <h3 class="footer-item-title text-color">INDIRIZZO</h3>
            <address class="desc mb-0">
              <p class="footer-item-desc text-color mb-0">{{ setting.footer.full_address }}</p>
            </address>
          </div>
        </div>
      </div>
    </div>
    <div class="container-fluid bottom-footer">
      <div class="row">
        <div class="col-12 text-center">
          <p class="copyright text-color">
            © {{ setting.agency.business_name }}
            @if (setting.agency.vat_number) {
              <span class="copyright"> | P.IVA {{ setting.agency.vat_number }} </span>
            }
            @if (setting.agency.license) {
              <span class="copyright"> | Licenza {{ setting?.agency?.license }} </span>
            }
            @if (setting?.agency?.rc) {
              <span class="copyright"> | RC {{ setting?.agency?.rc }} </span>
            }
            @if (setting?.agency?.insolvency_fund) {
              <span class="copyright"> | Fondo Insolvenza {{ setting?.agency?.insolvency_fund }} </span>
            }
            |
            <a class="text-color" routerLink="/privacy-policy">Privacy policy</a> -
            <a class="text-color" routerLink="/cookie-policy">Cookie policy</a>
          </p>
        </div>
      </div>
    </div>
  </div>
}
